import { AxiosStatusCode } from 'smg/axios';
import * as buttons from 'smg/buttons';
import * as models from 'smg/customer-api/models';
import * as session from 'smg/customer-api/session';
import { InitGoogleCredentialHandler } from 'smg/googlesignin';
import Modal from 'smg/modal';
import QueryString from 'smg/querystring';
import * as login from '../login';

main();

function main() {
    InitGoogleCredentialHandler();

    const email = document.querySelector('#email') as HTMLInputElement;
    const password = document.querySelector('#password') as HTMLInputElement;

    const returnUrl = QueryString().get('return');
    if (returnUrl) {
        const joinLink = document.querySelector('a[href*="join"]') as HTMLAnchorElement;
        if (joinLink) {
            const currentHref = joinLink.getAttribute('href') || '';
            joinLink.href = `${currentHref}?return=${encodeURIComponent(returnUrl)}`;
        }
    }

    const form = document.querySelector('#login-form') as HTMLFormElement;
    const fieldset = form.querySelector('fieldset') as HTMLFieldSetElement;
    const confirm = form.querySelector('[type="submit"]') as HTMLButtonElement;
    const alert = form.querySelector('.alert') as HTMLElement;
    const welcome = form.querySelector('h1') as HTMLHeadElement;
    const loginCode = document.querySelector('#login-code') as HTMLAnchorElement;

    alert.parentElement?.removeChild(alert);
    alert.classList.remove('d-none');

    const showAlert = (type: 'generic' | 'invalid-email' | 'email-unverified') => {
        const a = alert.cloneNode(true) as HTMLElement;
        const msg = a.querySelector(`.${type}`);
        msg?.classList.remove('d-none');

        welcome.after(a);
    };

    const hideAlert = () => {
        const a = form.querySelector('.alert');
        a?.parentElement?.removeChild(a);
    };

    form?.addEventListener('submit', e => {
        e.preventDefault();

        hideAlert();

        fieldset.setAttribute('disabled', 'disabled');
        buttons.Start(confirm);

        session.CreateSession({
            'email': email.value,
            'password': password.value,
        }).then(resp => {
            const data = models.SessionCreateResponse.fromJSON(resp.data);
            if (data.token) {
                session.SetLoginToken(data.token);
                login.RedirectAfterLogin();
                return;
            }

            throw Error('Login failed!');
        }).catch(async err => {
            fieldset.removeAttribute('disabled');
            buttons.Stop(confirm);

            switch (AxiosStatusCode(err)) {
            case 400:
                showAlert('invalid-email');
                return;
            case 401: {
                const prompt = await login.PromptLoginCode({ email: email.value });

                await prompt.login.then(() => {
                    login.RedirectAfterLogin();
                });

                return prompt.createCode;
            }
            }

            showAlert('generic');
        });
    });

    loginCode.addEventListener('click', e => {
        e.preventDefault();

        const body = (document.querySelector('#modal-login-code-email') as HTMLTemplateElement).content.cloneNode(true) as DocumentFragment;

        const modalEmail = body.querySelector('#modal-email') as HTMLInputElement;
        modalEmail.value = email.value;

        new Modal({
            body,
            onSubmit: async () => {
                const prompt = await login.PromptLoginCode({ email: modalEmail.value });

                await prompt.login.then(() => {
                    login.RedirectAfterLogin();
                });

                return prompt.createCode;
            },
            submitAutoFocus: false,
        });

        setTimeout(() => {
            modalEmail.focus();
            modalEmail.select();
        });
    });
}